import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    PeopleIqFilterSettingsFragment,
    GetPeopleIqFilterSettings as GetPeopleIqFilterSettingsQuery,
} from 'nutshell-graphql-types';

import GET_PEOPLE_IQ_FILTER_SETTINGS from '../queries/get-people-iq-filter-settings.graphql';

export function useGetPeopleIqFilterSettings(): {
    peopleIqFilterSettings: PeopleIqFilterSettingsFragment | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
} {
    const {data, error, loading} = useQuery<GetPeopleIqFilterSettingsQuery, Record<any, any>>(
        GET_PEOPLE_IQ_FILTER_SETTINGS,
        {}
    );

    return {
        peopleIqFilterSettings: data ? data.peopleIqFilterSettings : undefined,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
